import { render, staticRenderFns } from "./RigthBar.vue?vue&type=template&id=6d87aaf0&"
import script from "./RigthBar.vue?vue&type=script&lang=js&"
export * from "./RigthBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports